const styles = (theme) => ({
  chipSla: {
    color: theme.palette.white.main,
    fontWeight: "bold",
    borderRadius: "5px",
    height: "18px",
  },
});

export default styles;
